// extracted by mini-css-extract-plugin
module.exports = {"restaurant-menu-sidebar":"styles_restaurant-menu-sidebar__r5OZe","restaurant-menu-sidebar__header":"styles_restaurant-menu-sidebar__header__lW8bh"};